export const REGEX_ALL_DOTS = /\./g;
export const REGEX_ALL_PIPES = /\|/g;
